import React, {useState} from 'react';
import {UserInformationPane} from "./UserInformationPane";
import classNames from "classnames";
import {Category} from "../models";
import {Link} from 'react-router-dom';
import {useDeepLink} from "../util/utilites";

export type setCategoryType = (category: number) => void;

export interface CategoryViewerProps {
    categories: Category[];
    currentCategory: number;
    setCategory: setCategoryType;
}

export const CategoryViewer: React.FunctionComponent<CategoryViewerProps>  = ({ categories, currentCategory, setCategory}) => {
    const [getDeepLink] = useDeepLink();
    const [collapsed, setCollapsed] = useState(false);
    return (
        <div className="pane">
            <button type="button" title={collapsed ? 'Menu tonen' : 'Menu verbergen'} onClick={() => { setCollapsed(!collapsed); } } className={classNames('tool-button', { 'collapsed': collapsed } )}>{ collapsed ? '▼' : '▲'}</button>
            { !collapsed && categories.map( ({ Id, Code, Title }: Category) => (
                <Link to={`#/${getDeepLink({ currentCategory: Id })}`} key={Code} className={ classNames('button', { 'selected': currentCategory === Id})} onClick={() => { setCategory(Id); }}>
                    <span className="img"><img src={`images\\${Code}.jpg`} alt={ Code } /></span>
                    <span className="text">{ Title }</span>
                </Link>
            ))}
            { !collapsed && <UserInformationPane /> }
        </div>
    );
};
